import { messaging } from './messaging';
const messageList = {
    searchInvalidate() {
        messaging.sendMessage('SEARCH/INVALIDATE');
    },
};
export default messageList;
